import { Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { DEMO_LINK } from "@/App";

const PHONE_DISPLAY = "(972) 559-0010";
const PHONE_TEL = "tel:+19725590010";

const Footer = () => {
  return (
    <footer className="border-t border-line bg-ink py-16 md:py-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6">
          <div className="md:col-span-6">
            <a href="#top" className="font-heading text-2xl font-bold tracking-tight" data-testid="footer-logo">
              OrderHalal<span className="text-terra">.ai</span>
            </a>
            <p className="mt-4 max-w-md text-sand leading-relaxed">
              AI voice ordering that answers every call, takes orders accurately, and drops them
              right into your POS, 24/7.
            </p>
            <a
              href={DEMO_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-demo-button"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-terra px-6 py-3 text-sm font-semibold text-cream hover:bg-terra-hover transition-[background-color,transform] duration-300 hover:-translate-y-0.5"
            >
              Book a Free Demo
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold tracking-widest uppercase text-sand/70 mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href={PHONE_TEL} className="group inline-flex items-center gap-3 text-cream hover:text-terra transition-colors" data-testid="footer-phone-link">
                  <Phone className="w-4 h-4 text-terra" strokeWidth={1.5} />
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href="mailto:contact@orderhalal.ai" className="group inline-flex items-center gap-3 text-cream hover:text-terra transition-colors" data-testid="footer-email-link">
                  <Mail className="w-4 h-4 text-terra" strokeWidth={1.5} />
                  contact@orderhalal.ai
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold tracking-widest uppercase text-sand/70 mb-4">Web</h4>
            <p className="text-cream" data-testid="footer-domain">orderhalal.ai</p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-line flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-sm text-sand/60">© {new Date().getFullYear()} OrderHalal.ai. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="text-sm text-sand/60 hover:text-terra transition-colors" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-sand/60 hover:text-terra transition-colors" data-testid="footer-terms-link">
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
